var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.1667 6.66667H17.5C17.942 6.66667 18.366 6.84226 18.6785 7.15482C18.9911 7.46738 19.1667 7.89131 19.1667 8.33333V10.0867C19.1669 10.3045 19.1244 10.5202 19.0417 10.7217L16.4625 16.9842C16.3996 17.1368 16.2927 17.2674 16.1555 17.3592C16.0182 17.4511 15.8568 17.5001 15.6917 17.5H1.66667C1.44565 17.5 1.23369 17.4122 1.07741 17.2559C0.921131 17.0996 0.833333 16.8877 0.833333 16.6667V8.33333C0.833333 8.11232 0.921131 7.90036 1.07741 7.74408C1.23369 7.5878 1.44565 7.5 1.66667 7.5H4.56833C4.70175 7.50003 4.83322 7.46804 4.95169 7.4067C5.07017 7.34535 5.17219 7.25646 5.24917 7.1475L9.79333 0.708333C9.85078 0.626927 9.93549 0.5688 10.0321 0.544492C10.1287 0.520183 10.2309 0.531303 10.32 0.575833L11.8317 1.33167C12.2571 1.5443 12.5969 1.8961 12.7948 2.3286C12.9926 2.7611 13.0365 3.24827 12.9192 3.70917L12.1667 6.66667ZM5.83333 8.82333V15.8333H15.1333L17.5 10.0867V8.33333H12.1667C11.9128 8.3333 11.6624 8.27528 11.4344 8.16372C11.2064 8.05215 11.0069 7.88998 10.8511 7.68957C10.6953 7.48917 10.5873 7.25583 10.5354 7.00735C10.4835 6.75888 10.4891 6.50184 10.5517 6.25583L11.3042 3.29917C11.3277 3.20694 11.319 3.10943 11.2794 3.02286C11.2398 2.93629 11.1718 2.86587 11.0867 2.82333L10.5358 2.54833L6.61083 8.10833C6.4025 8.40333 6.13583 8.645 5.83333 8.82333V8.82333ZM4.16667 9.16667H2.5V15.8333H4.16667V9.16667Z",
    fill: "#03A828"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default ForwardRef;